export const data = [
    {
        id: 1,
        name: 'HTML/CSS',
        percentage: '80%',
    },
    {
        id: 2,
        name: 'JavaScript',
        percentage: '70%',
    },
    {
        id: 3,
        name: 'React',
        percentage: '70%',
    },
    {
        id: 4,
        name: 'TypeScript',
        percentage: '30%',
    },
    {
        id: 5,
        name: 'Angular',
        percentage: '40%',
    },
    {
        id: 6,
        name: 'MongoDB',
        percentage: '40%',
    },
    {
        id: 7,
        name: 'NodeJS',
        percentage: '40%',
    },
    {
        id: 8,
        name: 'Figma',
        percentage: '45%',
    }
]